var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: { "has-error": _vm.model.$error } },
    [
      _vm.showLabel
        ? _c("label", { staticClass: "control-label col-sm-4" }, [
            _vm._v(
              "* " +
                _vm._s(
                  _vm.$options.filters.sentenceCase(_vm.$t("organisation"))
                ) +
                ":"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: { "col-sm-8": _vm.showLabel } },
        [
          _c("selectize", {
            staticClass: "form-control selectize selectize-single",
            class: _vm.model.$error ? "has-error red-border" : "",
            attrs: { name: "company", options: _vm.clientUsers },
            on: {
              input: () => {
                _vm.$emit("input", _vm.model.$model)
              },
            },
            model: {
              value: _vm.model.$model,
              callback: function ($$v) {
                _vm.$set(_vm.model, "$model", $$v)
              },
              expression: "model.$model",
            },
          }),
          _vm._v(" "),
          _vm.model.$error
            ? _c("div", { staticClass: "help-block pull-right" }, [
                _vm._v("Client is required"),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }